import { render, staticRenderFns } from "./AdmissionScore.vue?vue&type=template&id=e6c2a130&"
import script from "./AdmissionScore.vue?vue&type=script&lang=js&"
export * from "./AdmissionScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports